/** Initiale fuers runde Hunde-Avatar ohne Foto: der erste Buchstabe bzw. die erste Ziffer des Namens. Ein fuehrendes
 * Leer- oder unsichtbares Zeichen (etwa aus einem kopierten Namen) liesse das Avatar mit charAt(0) sonst leer. */
export const dogInitial = (name: string | null | undefined): string => {
  const match = name?.match(/[\p{L}\p{N}]/u);
  return match ? match[0].toUpperCase() : '?';
};
